import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { DealersService } from 'src/app/share/services/dealers/dealers.service';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-dealer-details',
    templateUrl: './dealer-details.component.html',
    styleUrls: ['./dealer-details.component.scss'],
    standalone: false
})
export class DealerDetailsComponent implements OnInit {
  protected readonly faArrowLeft = faArrowLeft;
  addDealerForm: FormGroup
  isLoading = false;
  state: string = '';
  selectedDealerId: string;
  errorMessage: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dealersService: DealersService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {
    this.addDealerForm = this.formBuilder.group({
      name: ['', Validators.required],
      branchCode: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(RegExpPatterns.MobilePattern)]],
      delayAfterDelivery: [1, [Validators.min(0)]],
      creditLimit: [],
      gstNumber: [''],
      address: this.formBuilder.group({
        line1: ['', Validators.required],
        line2: [''],
        city: ['', Validators.required],
        state: ['', Validators.required],
        country: [''],
        pincode: ['', Validators.required]
      }),
    })
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.addDealerForm.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  onInputPincode(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 6) {
      inputElement.value = inputElement.value.slice(0, 6);
      (this.addDealerForm.get('address.pincode') || this.addDealerForm.controls['pincode'])?.setValue(inputElement.value);
    }
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.selectedDealerId = res['dId'];
    });
    if (this.selectedDealerId) {
      this.getDealerDetailsByDealerId()
    }
  }

  getDealerDetailsByDealerId() {
    this.dealersService.getDealerDetailsByDealerId(this.selectedDealerId).subscribe((res) => {
      this.addDealerForm.patchValue(res.data)
    })
  }

  saveDealerData() {
    this.isLoading = true;
    if (this.selectedDealerId) {
      this.dealersService.updateDealerDetails(this.selectedDealerId, this.addDealerForm.value).subscribe({
      next: (res) => {
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          }, 0);
          this.isLoading = false;
          this.router.navigate(['/dealer-list']);
        },
      error: (error: any) => {
          this.isLoading = false;
          console.log(error);
          this.errorMessage = error?.error?.error?.message;
        }
    });
    } else {
      this.dealersService.saveDealerDetails(this.addDealerForm.value).subscribe({
      next: (res: any) => {
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          }, 0);
          this.isLoading = false;
          this.router.navigate(['/dealer-list']);
        },
      error: (error: any) => {
          this.isLoading = false;
          console.log(error);
          this.errorMessage = error?.error?.error?.message;
        }
    });
    }
  }

}
